import React, { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "../apiClient";

const OnlineContext = createContext();

export const OnlineProvider = ({ children }) => {
  
  const user= JSON.parse(localStorage.getItem('seo_app')); 
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
  const [online, setOnline] = useState(user != null);
  const [dashboardTutorialSeen, setDashboardTutorialSeen] = useState(true);
  const [accountTutorialSeen, setAccountTutorialSeen] = useState(true);
  

  //check if user is new, if yes , show the tutorial
  useEffect(() => {

    if(user)
      apiClient.get(process.env.REACT_APP_BACK+"/users/tutorial_is_seen/"+user?._id, config)
        .then((response) => {
          if (response.status == 200)
          {
            setDashboardTutorialSeen(response.data.dashboardTutorialSeen);
            setAccountTutorialSeen(response.data.accountTutorialSeen);
          }
          
          
        })
        .catch((error) => {
          console.log("axios error");
     
        });
    
    
  }, [user]);

  return (
    <OnlineContext.Provider value={{ online, setOnline , dashboardTutorialSeen , setDashboardTutorialSeen ,
     accountTutorialSeen , setAccountTutorialSeen }}>
      {children}
    </OnlineContext.Provider>
  );
};

export const useOnlineStatus = () => {
  return useContext(OnlineContext);
};
